module.exports = __webpack_public_path__ + "static/atom-ai-91869cbd6bf908dbe100132064e9317f.jpg";